var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import styles from './MilestoneDeliversTable.module.scss';
import columnSharedStyles from '@app/Components/Grid/SharedStyles/column-shared-styles.module.scss';
import { observer } from 'mobx-react';
import { Grid } from '@app/Components/Grid/Grid';
import { Column } from 'devextreme-react/data-grid';
import { Api } from '@app/Api';
import { observable, action } from 'mobx';
import { FunctionFilterContext } from '@app/Components/FunctonFilter/FunctionFilterContext';
import { filterDeliverableTableRowsByFunction } from '@app/Components/FunctonFilter/FunctionFilter';
import { ChecklistSections, ObjectType, SignalREvents, GateProcessTypeEnum, ChecklistItemType } from '@app/AppConstants';
import { RatingCell } from '@app/Components/Grid/RatingCell/RatingCell';
import { EditCell } from '@app/Components/Grid/EditCell/EditCell';
import { createUniqueId } from '@app/Helpers/UidHelper/UidHelper';
import HTMLReactParser from 'html-react-parser';
import { signalRService } from '@app/Services/SignalRService';
import { DocumentButton } from '@app/Components/DocumentButton/DocumentButton';
import { ChangeLogDialog } from '@app/Components/Dialogs/ChangeLogDialog';
import { AddActionItemWrapper } from '@app/Components/AddActionItemWrapper/AddActionItemWrapper';
import { CodeCell } from '@app/Components/Grid/CodeCell/CodeCell';
import { ApproveButton } from '@app/Pages/ProjectView/ProjectViewTabs/GatePreparations/ApprovedGateView/ApprovedChecklistView/ApprovedChecklistDeliversTable/ApproveButton/ApproveButton';
import { ApproveDenyDeliverableButtons } from '@app/Pages/ProjectView/ProjectViewTabs/GateDeliverables/DeliversTable/ApproveDenyDeliverableButtons';
import { Button } from '@app/Components/Button/Button';
import { ApproversModal } from '@app/Pages/ProjectView/ProjectViewTabs/GateDeliverables/DeliversTable/ApproversModal';
import { CommentModal } from '@app/Widgets/CommentModal/CommentModal';
import { ExternalProviderButton } from '../../GatePreparations/ApprovedGateView/ApprovedChecklistView/ExternalProviderButton/ExternalProviderButton';
export var MilestoneDeliversTable = /** @class */ (function (_super) {
    __extends(MilestoneDeliversTable, _super);
    function MilestoneDeliversTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._delivers = [];
        _this._currentChecklistitem = null;
        _this._currentDeliverable = null;
        _this._denyItem = null;
        _this._unapprovedDeliverable = null;
        _this._denyApprovalId = undefined;
        _this._loading = false;
        _this._isApproversModalOpen = false;
        _this._isCommentModalOpen = false;
        _this._isUnapproveDeliverableModalOpen = false;
        _this._gridRef = React.createRef();
        return _this;
    }
    MilestoneDeliversTable.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadDelivers()];
                    case 1:
                        _a.sent();
                        signalRService.subscribe(SignalREvents.decisionChanged, this._loadDelivers);
                        signalRService.subscribe(SignalREvents.recommendationChanged, this._loadDelivers);
                        return [2 /*return*/];
                }
            });
        });
    };
    MilestoneDeliversTable.prototype.componentWillUnmount = function () {
        signalRService.unsubscribe(SignalREvents.decisionChanged, this._loadDelivers);
        signalRService.unsubscribe(SignalREvents.recommendationChanged, this._loadDelivers);
    };
    MilestoneDeliversTable.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(prevProps.gateId !== this.props.gateId ||
                            prevProps.hideNAItems !== this.props.hideNAItems ||
                            prevProps.isFilesChanged !== this.props.isFilesChanged)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._loadDelivers()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    MilestoneDeliversTable.prototype.reload = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadDelivers()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MilestoneDeliversTable.prototype._savePMDeliverable = function (rowData) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 6]);
                        return [4 /*yield*/, Api.secured.updateMilestoneDeliverable({ body: rowData })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.props.onRefreshChecklistStatusOverview()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 3:
                        error_1 = _a.sent();
                        if (!error_1) return [3 /*break*/, 5];
                        console.error(error_1);
                        return [4 /*yield*/, this._loadDelivers()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    MilestoneDeliversTable.prototype._savePMDeliverableRating = function (rowData, rowIndex) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var row_1, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 4, , 7]);
                        return [4 /*yield*/, Api.secured.updateMilestoneDeliverable({ body: rowData })];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, Api.secured.getMilestoneDeliverable({ checklistItemId: rowData.id })];
                    case 2:
                        row_1 = _b.sent();
                        (_a = Object.keys(rowData)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                            rowData[key] = row_1[key];
                        });
                        if (this._gridRef.current) {
                            this._gridRef.current.repaintRows([rowIndex]);
                        }
                        return [4 /*yield*/, this.props.onRefreshChecklistStatusOverview()];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 4:
                        error_2 = _b.sent();
                        if (!error_2) return [3 /*break*/, 6];
                        console.error(error_2);
                        return [4 /*yield*/, this._loadDelivers()];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6: return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    MilestoneDeliversTable.prototype._loadDelivers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var projectId, gateId, hideNAItems, _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        projectId = (_b = this.props, _b.projectId), gateId = _b.gateId, hideNAItems = _b.hideNAItems;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, , 3, 4]);
                        this._loading = true;
                        _a = this;
                        return [4 /*yield*/, Api.secured.getMilestoneDeliverables({
                                projectId: projectId,
                                gateId: gateId,
                                hideNAItems: hideNAItems
                            })];
                    case 2:
                        _a._delivers = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this._loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MilestoneDeliversTable.prototype._handleDeny = function (comment) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 3, 5]);
                        this._loading = true;
                        if (!(this._denyItem && this._denyApprovalId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Api.secured.denyDeliverable(this._denyItem.id, {
                                approvalId: this._denyApprovalId,
                                comment: comment
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this._denyItem = null;
                        return [3 /*break*/, 5];
                    case 3:
                        this._loading = false;
                        return [4 /*yield*/, this._refreshDeliverables()];
                    case 4:
                        _a.sent();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MilestoneDeliversTable.prototype._handleUndoApproval = function (comment) {
        return __awaiter(this, void 0, void 0, function () {
            var id, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this._unapprovedDeliverable)
                            return [2 /*return*/];
                        id = this._unapprovedDeliverable.id;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 7, 8]);
                        this._loading = true;
                        _a = this._unapprovedDeliverable.checkListItemType;
                        switch (_a) {
                            case ChecklistItemType.MasterDeliverableWithoutFunctionDeliverable: return [3 /*break*/, 2];
                            case ChecklistItemType.MasterDeliverable: return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 6];
                    case 2: return [4 /*yield*/, Api.secured.undoDeliverableApprovalWithoutInput(id, { comment: comment })];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, Api.secured.undoMasterDeliverable(id, { comment: comment })];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        this._loading = false;
                        return [7 /*endfinally*/];
                    case 8: return [4 /*yield*/, this._refreshDeliverables()];
                    case 9: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    MilestoneDeliversTable.prototype._handleUndoApprovalClick = function (deliverable) {
        this._toggleUnapproveDeliverableModalOpen();
        this._unapprovedDeliverable = deliverable;
    };
    MilestoneDeliversTable.prototype._toggleLogModal = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._currentChecklistitem = null;
                return [2 /*return*/];
            });
        });
    };
    MilestoneDeliversTable.prototype._toggleCommentModalOpen = function () {
        this._isCommentModalOpen = !this._isCommentModalOpen;
        if (!this._isCommentModalOpen)
            this._denyItem = null;
    };
    MilestoneDeliversTable.prototype._toggleUnapproveDeliverableModalOpen = function () {
        this._isUnapproveDeliverableModalOpen = !this._isUnapproveDeliverableModalOpen;
        if (!this._isUnapproveDeliverableModalOpen)
            this._unapprovedDeliverable = null;
    };
    MilestoneDeliversTable.prototype._refreshDeliverables = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._loadDelivers()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.props.onRefreshChecklistStatusOverview()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MilestoneDeliversTable.prototype._toggleApproversModal = function () {
        this._isApproversModalOpen = !this._isApproversModalOpen;
    };
    MilestoneDeliversTable.prototype._onApprovalChangedHandler = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._toggleApproversModal();
                        return [4 /*yield*/, this._refreshDeliverables()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MilestoneDeliversTable.prototype._showApprovers = function (deliverable) {
        if (deliverable) {
            this._currentDeliverable = deliverable;
            this._toggleApproversModal();
        }
    };
    MilestoneDeliversTable.prototype._denyDeliverable = function (deliverable) {
        if (deliverable) {
            this._toggleCommentModalOpen();
            this._denyItem = deliverable;
            this._denyApprovalId = deliverable.approvalId;
        }
    };
    MilestoneDeliversTable.prototype.render = function () {
        var _a;
        var _this = this;
        var projectId = (_a = this.props, _a.projectId), gateId = _a.gateId, gateName = _a.gateName, projectCodeName = _a.projectCodeName, onRefreshActionItems = _a.onRefreshActionItems, onDocumentIconClick = _a.onDocumentIconClick, showRedDotDeliverable = _a.showRedDotDeliverable, isProjectTerminatedOrCompleted = _a.isProjectTerminatedOrCompleted;
        var functionFilterValue = this.context;
        var rows = filterDeliverableTableRowsByFunction(this._delivers, functionFilterValue);
        return (React.createElement(React.Fragment, null,
            React.createElement(Grid, { ref: this._gridRef, dataSource: __spreadArray([], rows, true), expandableRows: true, rowsCount: rows.length, loading: this._loading },
                React.createElement(Column, { caption: "ID", dataField: "code", width: 100, allowEditing: false, cssClass: columnSharedStyles.colWithHistory, cellRender: function (_a) {
                        var data = _a.data;
                        return (React.createElement(CodeCell, { code: data.code, onHistoryClick: function () { return (_this._currentChecklistitem = data); } }, data.canPrincipalUpdateProjectManagerPart && (React.createElement(ExternalProviderButton, { projectName: projectCodeName, projectId: projectId, gateId: gateId, gateCodeName: gateName, checkListItemId: data.id, taskId: data.taskId || null, taskStatus: data.taskStatus, onRefresh: _this._loadDelivers, disable: isProjectTerminatedOrCompleted }))));
                    } }),
                React.createElement(Column, { caption: "Key Deliverables", dataField: "keyDeliverables", width: 350, allowEditing: false, cellRender: function (_a) {
                        var data = _a.data;
                        return React.createElement("div", { style: { whiteSpace: 'pre-line' } }, HTMLReactParser(data.keyDeliverables));
                    } }),
                React.createElement(Column, { caption: "Details", dataField: "guideline", minWidth: 300, allowEditing: false, cellRender: function (_a) {
                        var data = _a.data;
                        return React.createElement("div", { style: { whiteSpace: 'pre-line' } }, HTMLReactParser(data.guideline));
                    } }),
                React.createElement(Column, { caption: "Project Manager comment", width: 300, dataField: "projectManagerComment", cssClass: columnSharedStyles.commentColumn, cellRender: function (_a) {
                        var data = _a.data, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
                        return (React.createElement(EditCell, { rowIndex: rowIndex, columnIndex: columnIndex, value: data.projectManagerOriginalComment, onChange: function (value) {
                                data.projectManagerOriginalComment = value;
                                if (_this._gridRef.current) {
                                    _this._gridRef.current.repaintRows([rowIndex]);
                                }
                            }, onSave: function () { return _this._savePMDeliverable(data); }, objectUniqueId: createUniqueId(ObjectType.ChecklistItem, data.id), withCopy: true, disabled: !data.canPrincipalUpdateProjectManagerPart || isProjectTerminatedOrCompleted, section: ChecklistSections.ProjectManager }));
                    } }),
                React.createElement(Column, { headerCellRender: function () { return React.createElement("div", { title: "Project Manager Rating" }, "Rating"); }, width: 110, cellRender: function (_a) {
                        var _b, _c;
                        var data = _a.data, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
                        return (React.createElement(AddActionItemWrapper, { projectId: projectId, gateId: gateId, gateProcessType: GateProcessTypeEnum.GateMeeting, disabled: !data.canPrincipalAddActionItem || isProjectTerminatedOrCompleted, data: data, isForProjectManager: true, onActionItemSave: onRefreshActionItems },
                            React.createElement(React.Fragment, null,
                                React.createElement(RatingCell, { rowIndex: rowIndex, columnIndex: columnIndex, onSave: function () { return _this._savePMDeliverableRating(data, rowIndex); }, onChange: function (value) {
                                        data.projectManagerRating = value;
                                        if (_this._gridRef.current) {
                                            _this._gridRef.current.repaintRows([rowIndex]);
                                        }
                                    }, rating: data.projectManagerRating, objectUniqueId: createUniqueId(ObjectType.ChecklistItem, data.id), disabled: !data.canPrincipalUpdateProjectManagerPart || isProjectTerminatedOrCompleted, section: ChecklistSections.ProjectManager, controlId: "pmRating".concat(data.id) }),
                                data.masterDeliverable && (React.createElement("div", { className: styles.statusButton },
                                    data.masterDeliverable.isReadyForApprovalVisible && (React.createElement(ApproveButton, { deliverable: data.masterDeliverable, rating: data.projectManagerRating, comment: data.projectManagerOriginalComment, isDisabled: !data.masterDeliverable.canPrincipalSetInApprovalDeliverable ||
                                            isProjectTerminatedOrCompleted, onPrepare: _this._refreshDeliverables, hasRedDot: ((_b = data.masterDeliverable) === null || _b === void 0 ? void 0 : _b.hasRedDot) && showRedDotDeliverable, hasDocument: data.hasDocuments, showValidationError: true })),
                                    !_this._isApproversModalOpen &&
                                        !_this._loading &&
                                        data.masterDeliverable.isApprovalActionVisible && (React.createElement(ApproveDenyDeliverableButtons, { deliverable: data.masterDeliverable, deliverableApproverId: data.masterDeliverable
                                            .canPrincipalImmediateApproveDeliverable
                                            ? null
                                            : data.masterDeliverable.approvalId || null, canApproveWithoutApprover: data.masterDeliverable
                                            .canPrincipalImmediateApproveDeliverable, isApproveDisabled: _this._isApproversModalOpen || _this._loading, onDenyHandler: function () {
                                            return _this._denyDeliverable(data.masterDeliverable);
                                        }, onApprovedHandler: _this._refreshDeliverables, parentClassName: styles.approveDenyBlock, childClassName: styles.approveDenyButton, disabled: isProjectTerminatedOrCompleted })),
                                    data.masterDeliverable.canPrincipalSetToDraftDeliverable && (React.createElement(Button, { className: styles.action, size: "sm", color: "success", onClick: function () {
                                            return _this._handleUndoApprovalClick(data.masterDeliverable);
                                        }, disabled: _this._loading || isProjectTerminatedOrCompleted }, "Undo Approval")))),
                                React.createElement("div", { className: styles.commentActions },
                                    React.createElement("div", { className: "".concat(styles.commentAction, " ").concat(styles.documentIconWrapper) },
                                        onDocumentIconClick && (React.createElement(DocumentButton, { hasDocument: data.hasDocuments, onDocumentIconClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, (onDocumentIconClick === null || onDocumentIconClick === void 0 ? void 0 : onDocumentIconClick(data.id, ChecklistSections.ProjectManager))];
                                                        case 1: return [2 /*return*/, _a.sent()];
                                                    }
                                                });
                                            }); }, hasRedDot: ((_c = data.masterDeliverable) === null || _c === void 0 ? void 0 : _c.hasRedDot) && showRedDotDeliverable })),
                                        data.masterDeliverable && data.masterDeliverable.isApprovalButtonVisible && (React.createElement(Button, { color: "success", size: "xs", className: styles.approversButton, onClick: function () { return _this._showApprovers(data.masterDeliverable); } }, "A")))))));
                    } })),
            this._currentChecklistitem && (React.createElement(ChangeLogDialog, { onToggle: this._toggleLogModal, uniqueId: createUniqueId(ObjectType.ChecklistItem, this._currentChecklistitem.id) })),
            React.createElement(CommentModal, { isOpen: this._isUnapproveDeliverableModalOpen, onToggle: this._toggleUnapproveDeliverableModalOpen, onSave: this._handleUndoApproval }),
            React.createElement(CommentModal, { isOpen: this._isCommentModalOpen, onToggle: this._toggleCommentModalOpen, onSave: this._handleDeny }),
            React.createElement(ApproversModal, { isOpen: this._isApproversModalOpen, toggle: this._toggleApproversModal, onApprovalChanged: this._onApprovalChangedHandler, deliverable: this._currentDeliverable, isProjectTerminatedOrCompleted: isProjectTerminatedOrCompleted })));
    };
    MilestoneDeliversTable.contextType = FunctionFilterContext;
    __decorate([
        observable
    ], MilestoneDeliversTable.prototype, "_delivers", void 0);
    __decorate([
        observable
    ], MilestoneDeliversTable.prototype, "_currentChecklistitem", void 0);
    __decorate([
        observable
    ], MilestoneDeliversTable.prototype, "_currentDeliverable", void 0);
    __decorate([
        observable
    ], MilestoneDeliversTable.prototype, "_denyItem", void 0);
    __decorate([
        observable
    ], MilestoneDeliversTable.prototype, "_unapprovedDeliverable", void 0);
    __decorate([
        observable
    ], MilestoneDeliversTable.prototype, "_denyApprovalId", void 0);
    __decorate([
        observable
    ], MilestoneDeliversTable.prototype, "_loading", void 0);
    __decorate([
        observable
    ], MilestoneDeliversTable.prototype, "_isApproversModalOpen", void 0);
    __decorate([
        observable
    ], MilestoneDeliversTable.prototype, "_isCommentModalOpen", void 0);
    __decorate([
        observable
    ], MilestoneDeliversTable.prototype, "_isUnapproveDeliverableModalOpen", void 0);
    __decorate([
        observable.ref
    ], MilestoneDeliversTable.prototype, "_gridRef", void 0);
    __decorate([
        action.bound
    ], MilestoneDeliversTable.prototype, "reload", null);
    __decorate([
        action.bound
    ], MilestoneDeliversTable.prototype, "_savePMDeliverable", null);
    __decorate([
        action.bound
    ], MilestoneDeliversTable.prototype, "_savePMDeliverableRating", null);
    __decorate([
        action.bound
    ], MilestoneDeliversTable.prototype, "_loadDelivers", null);
    __decorate([
        action.bound
    ], MilestoneDeliversTable.prototype, "_handleDeny", null);
    __decorate([
        action.bound
    ], MilestoneDeliversTable.prototype, "_handleUndoApproval", null);
    __decorate([
        action.bound
    ], MilestoneDeliversTable.prototype, "_handleUndoApprovalClick", null);
    __decorate([
        action.bound
    ], MilestoneDeliversTable.prototype, "_toggleLogModal", null);
    __decorate([
        action.bound
    ], MilestoneDeliversTable.prototype, "_toggleCommentModalOpen", null);
    __decorate([
        action.bound
    ], MilestoneDeliversTable.prototype, "_toggleUnapproveDeliverableModalOpen", null);
    __decorate([
        action.bound
    ], MilestoneDeliversTable.prototype, "_refreshDeliverables", null);
    __decorate([
        action.bound
    ], MilestoneDeliversTable.prototype, "_toggleApproversModal", null);
    __decorate([
        action.bound
    ], MilestoneDeliversTable.prototype, "_onApprovalChangedHandler", null);
    __decorate([
        action.bound
    ], MilestoneDeliversTable.prototype, "_showApprovers", null);
    __decorate([
        action.bound
    ], MilestoneDeliversTable.prototype, "_denyDeliverable", null);
    MilestoneDeliversTable = __decorate([
        observer
    ], MilestoneDeliversTable);
    return MilestoneDeliversTable;
}(React.PureComponent));
